import { Badge } from '@/shared/ui/badge';
import { Button } from '@/shared/ui/button';
import { SlidersHorizontal } from 'lucide-react';
import { useState } from 'react';
import { WorkOrdersFilterDropdowns } from './WorkOrdersFilterDropdowns';
import { WorkOrdersSearch } from './WorkOrdersSearch';

interface WorkOrdersFiltersProps {
  searchTerm: string;
  priorityFilter: string;
  jobTypeFilter: string;
  workOrderStatusFilter: string;
  mirPendingDirectionFilter: string;
  onSearchTermChange: (value: string) => void;
  onApplyFilters: (values: {
    priority: string;
    jobType: string;
    status: string;
    mir: string;
    searchTerm: string;
  }) => void;
  onResetFilters: () => void;
}

export function WorkOrdersFilters({
  searchTerm,
  priorityFilter,
  jobTypeFilter,
  workOrderStatusFilter,
  mirPendingDirectionFilter,
  onSearchTermChange,
  onApplyFilters,
  onResetFilters,
}: WorkOrdersFiltersProps) {
  const [panelOpen, setPanelOpen] = useState(false);

  const activeCount = [
    priorityFilter,
    jobTypeFilter,
    workOrderStatusFilter,
    mirPendingDirectionFilter,
  ].filter((v) => v !== 'all').length;

  const handleApply = (values: {
    priority: string;
    jobType: string;
    status: string;
    mir: string;
  }) => {
    onApplyFilters({ ...values, searchTerm });
    setPanelOpen(false);
  };

  const handleResetAll = () => {
    onResetFilters();
  };

  const handleClear = () => {
    onResetFilters();
    setPanelOpen(false);
  };

  return (
    <div className="flex items-center gap-2 ml-[5px]">
      <WorkOrdersSearch searchTerm={searchTerm} onSearchTermChange={onSearchTermChange} />
      <Button
        variant="outline"
        onClick={() => setPanelOpen(true)}
        className="border-border hover:bg-accent rounded-lg h-9"
      >
        <SlidersHorizontal className="w-4 h-4 mr-2" />
        Filters
        {activeCount > 0 && (
          <Badge className="ml-2 h-5 min-w-[20px] px-1.5 flex items-center justify-center rounded-full bg-orange-600 text-white text-[10px]">
            {activeCount}
          </Badge>
        )}
      </Button>

      <Button
        variant="outline"
        onClick={handleResetAll}
        disabled={activeCount === 0 && searchTerm === ''}
        className="border-border hover:bg-accent rounded-lg h-9"
      >
        Reset Filters
      </Button>

      <WorkOrdersFilterDropdowns
        isOpen={panelOpen}
        onClose={() => setPanelOpen(false)}
        priorityFilter={priorityFilter}
        jobTypeFilter={jobTypeFilter}
        workOrderStatusFilter={workOrderStatusFilter}
        mirPendingDirectionFilter={mirPendingDirectionFilter}
        onApply={handleApply}
        onClear={handleClear}
      />
    </div>
  );
}
